import getConfig from "next/config";

export const isInUnifiedRouting = () => {

  if(typeof global.window === 'undefined') return false;

  if(process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH) {
      const firstPart = (window.location.pathname + "/").split('/')[1];
      if (firstPart === process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH) {
          return true;
      }
  }
  
  return false;
}

export const addUnifiedRoutingToUrl = (url: string): string => {
  let newUrl = url;
  if(typeof url !== 'string')
    newUrl = '';

  if(newUrl.startsWith('http') || !isInUnifiedRouting()) {
    return newUrl;
  }  

  if (!newUrl.startsWith(`/${process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH}`)) {
    newUrl = `/${process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH}/${newUrl}`;
  }  

  newUrl = newUrl
              .replace(/^\/[^/?]+(\/)?/g, `/${process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH}/`)   
              .replace(/\/\//g, '/'); // Remove double slashes 

  return newUrl;
}

export const getMspApiUrl = (): string => {
  return (isInUnifiedRouting()) ? getConfig().publicRuntimeConfig.mslpApiUnifiedBaseUrl
                                : getConfig().publicRuntimeConfig.mslpApiBaseUrl;
}
